export type MessageSegment =
  | { type: "text"; value: string }
  | { type: "link"; value: string }

// http/https only — no bare www., no scheme inference. This can never yield a
// javascript: or data: href, so the rendered <a> is safe by construction.
const URL_PATTERN = /https?:\/\/[^\s]+/gi

// A URL at the end of a sentence swallows the punctuation ("see https://x.com.")
// so peel a trailing run back into the text it belongs to.
const TRAILING_PUNCTUATION = /[.,;:!?)\]}'"]+$/

/**
 * Split a message body into plain-text and link segments. Pure and React-free:
 * the caller renders each segment as a text node or an <a>, so the body stays
 * escaped by construction and no HTML sanitizer is needed.
 */
export function linkify(body: string): MessageSegment[] {
  const segments: MessageSegment[] = []
  let cursor = 0

  for (const match of body.matchAll(URL_PATTERN)) {
    const start = match.index
    const url = match[0].replace(TRAILING_PUNCTUATION, "")

    if (start > cursor) {
      segments.push({ type: "text", value: body.slice(cursor, start) })
    }
    segments.push({ type: "link", value: url })
    // Any peeled punctuation sits between here and the next match, so the next
    // text slice picks it up.
    cursor = start + url.length
  }

  if (cursor < body.length) {
    segments.push({ type: "text", value: body.slice(cursor) })
  }

  return segments
}
